import React from "react";
import { Navigate, useParams } from "react-router-dom";

/**
Backward-compatible redirect for the retired `/teams/:teamId/projects` route (bookmarks, external
links) - the real page is now the single `/projects` route, scoped via the `teamId` query parameter.
*/
const TeamProjectsRouteRedirect: React.FC = () => {
  const { teamId } = useParams<{ teamId: string }>();
  return <Navigate to={`/projects?teamId=${teamId}`} replace />;
};

export default TeamProjectsRouteRedirect;
